<div class="row">
    <div class="col">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-6 rounded p-2 text-white bg-native">
                        <img src="{{photo}}" class="img-thumbnail">
                        <h1 class="card-title">{{uName}}</h1>
                        <small class="card-subtitle">Member since
                            {{ sinceMember | date: "MMM d, y"}}</small>
                    </div>
                    <div class="col-6 text-white rounded ms-auto">
                        <ul class="list-group">
                            <li class='list-group-item text-dark bg-light'>
                                Summary of Submissions
                            </li>
                            <li class='list-group-item text-dark'>
                                <span class="badge bg-dark">{{articles.length}}</span> Articles Published
                            </li>
                            <li class='list-group-item text-dark'>
                                <span class="badge bg-dark">{{events.length}}</span> Events Published
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row p-3">
    <div class='card'>
        <div class="card-header">
            <h4 class="card-title">Articles</h4>
            <button class="btn btn-outline-primary" routerLink="/add-article" *ngIf="auth.user | async as user">
                Add
            </button>
        </div>
        <div class=" card-body ">
            <ul class="list-group ">
                <li class="list-group-item " *ngFor="let article of articles ">
                    <h2 class="card-title ">Article 1</h2>
                    <h6 class="card-subtitle content ">Timeline Label: {{article.label}}</h6>
                    <h6 class="card-subtitle content ">Timeline Full Name: {{article.fullname}}</h6>
                    <h6 class="card-subtitle content ">Timeline Description: {{article.description}}</h6>
                    <h6 class="card-subtitle content ">Timeline Tag: {{article.tag}}</h6>
                    <h6 class="card-subtitle content ">Timeline Narrative: {{article.narrative}}</h6>
                    <h6 class="card-subtitle content ">Timeline Paragraphs: {{article.paragraphs}}
                    </h6>
                    <h6 class="card-subtitle content ">Timeline Relevant Link: {{article.relLink}}</h6>
                    <h6 class="card-subtitle content ">Timeline Image Link: {{article.imgLink}}</h6>
                    <div class='text-end'>
                        <small class='text-start text-{{article.color}}'>
                            {{article.action}} {{ article.timestamp?.toDate() | date: 'MM/dd/yyyy, h:mm:ss a' }}
                        </small>
                        <small class='text-start text-secondary' *ngIf="article.submittedBy">
                            by {{article.submittedBy}}
                        </small>
                    </div>
                    <div class="btn-group float-end " *ngIf="auth.user | async as user">
                        <button class="btn btn-outline-secondary " (click)="editArticle(article.id) ">
                            Edit
                        </button>
                        <button class="btn btn-outline-danger " (click)="delArticle(article.id) ">
                            Delete
                        </button>
                    </div>
                </li>
            </ul>
            <h6 class="text-center " *ngIf='articles.length === 0'>No articles posted</h6>
        </div>
    </div>
</div>

<div class="row m-3" id="events">
    <div class="card">
        <div class="card-header">
            <h4 class="card-title" id="articles">Latest Events Posted </h4>
            <a class="btn btn-outline-primary float-end " routerLink="/add-event" *ngIf="auth.user | async as user">
                Add
            </a>
        </div>

        <div class="card-body">
            <ul class="list-group " *ngIf="events.length> 0">
                <li class=" list-group-item " *ngFor="let event of events ">
                    <h6 class="card-subtitle content ">Event Name: {{event.name}}</h6>
                    <h6 class="card-subtitle content">Starting Period: {{ monthToString(event.startPeriod.month) }}
                        {{event.startPeriod.day}}<small *ngIf='event.startPeriod.day'>,</small>
                        {{event.startPeriod.year}}</h6>
                    <h6 class="card-subtitle content" *ngIf="event.endPeriod">Ending Period:
                        {{ monthToString(event.endPeriod.month) }} {{event.endPeriod.day }}<small
                            *ngIf='event.endPeriod.day'>,</small>
                        {{event.endPeriod.year }}</h6>
                    <h6 class="card-subtitle content " *ngIf="event.location">Event Location: {{event.location}}
                    </h6>
                    <h6 class="card-subtitle content" *ngIf="event.tags">Event Tag Cloud:
                        <span class='btn-group d-flex'>
                            <a routerLink='/search-tags/{{tag}}'
                                class='btn btn-sm btn-secondary border border-white rounded text-truncate'
                                *ngFor='let tag of event.tags' title='Tag lookup: {{tag}}'>{{tag}}</a>
                        </span>
                    </h6>
                    <h6 class="card-subtitle content text-wrap" *ngIf="event.description">
                        Event Description: <i>{{event.description | slice: 0:95}}</i><a href='#'
                            *ngIf='event.description.length > 95' title="{{ event.description}} ">
                            [...]</a>
                    </h6>
                    <h6 class="card-subtitle content " *ngIf="event.relLink">Event Relevant Link:
                        <a href="{{event.relLink}} " title="{{event.relLink}} " target="_blank">{{event.relLink |
                            slice: 0:95}}</a>
                    </h6>
                    <h6 class="card-subtitle content " *ngIf="event.imgLink">Event Image Link:
                        <a href="{{event.imgLink}}" title="{{event.imgLink}} " target="_blank">{{event.imgLink |
                            slice: 0:95}}</a>
                    </h6>

                    <div class='text-end'>
                        <small class='text-start text-{{event.color}}'>
                            {{event.action}} {{ event.timestamp?.toDate() | date: 'MM/dd/yyyy, h:mm:ss a' }}

                        </small>
                        <small class='text-start text-secondary' *ngIf="event.submittedBy">
                            by {{event.submittedBy}}
                        </small>
                    </div>


                    <div class=" btn-group float-end m-3 " *ngIf="auth.user | async as user">
                        <button class="btn btn-sm btn-outline-secondary " (click)="editEvent(event)"
                            *ngIf="user.displayName  === event.submittedBy">
                            Edit
                        </button>
                        <button class="btn btn-sm btn-outline-danger " title="Delete " (click)="delEvent(event) "
                            *ngIf="user.displayName  === event.submittedBy">
                            Delete
                        </button>
                    </div>
                </li>
            </ul>

            <h6 class="text-center " *ngIf='events.length === 0'>No events posted</h6>
        </div>
    </div>
</div>